module.exports = __webpack_public_path__ + "img/wabi.1344929a.svg";